function getConsentMiddleware(destinationPreferences, categoryPreferences, defaultDestinationBehavior) {
  return function (_a) {
    var payload = _a.payload,
        next = _a.next;
    payload.obj.context.consent = {
      defaultDestinationBehavior: defaultDestinationBehavior,
      categoryPreferences: categoryPreferences,
      destinationPreferences: destinationPreferences
    };
    next(payload);
  };
}

export default function conditionallyLoadAnalytics(_a) {
  var writeKey = _a.writeKey,
      destinations = _a.destinations,
      destinationPreferences = _a.destinationPreferences,
      isConsentRequired = _a.isConsentRequired,
      _b = _a.shouldReload,
      shouldReload = _b === void 0 ? true : _b,
      defaultDestinationBehavior = _a.defaultDestinationBehavior,
      categoryPreferences = _a.categoryPreferences;
  var wd = window;
  var integrations = {
    All: false,
    'Segment.io': true
  };
  var isAnythingEnabled = false;

  if (!destinationPreferences) {
    if (isConsentRequired) {
      return;
    } // Load a.js normally when consent isn't required and there's no preferences


    if (!wd.analytics.initialized) {
      wd.analytics.load(writeKey);
    }

    return;
  }

  for (var _i = 0, destinations_1 = destinations; _i < destinations_1.length; _i++) {
    var destination = destinations_1[_i]; // Was a preference explicitly set on this destination?

    var explicitPreference = (destination.id in destinationPreferences);

    if (!explicitPreference && defaultDestinationBehavior === 'enable') {
      integrations[destination.id] = true;
      continue;
    }

    var isEnabled = Boolean(destinationPreferences[destination.id]);

    if (isEnabled) {
      isAnythingEnabled = true;
    }

    integrations[destination.id] = isEnabled;
  } // Reload the page if the trackers have already been initialised so that
  // the user's new preferences can take affect


  if (wd.analytics && wd.analytics.initialized) {
    if (shouldReload) {
      window.location.reload();
    }

    return;
  } // Don't load a.js at all if nothing has been enabled


  if (isAnythingEnabled) {
    var middleware = getConsentMiddleware(destinationPreferences, categoryPreferences, defaultDestinationBehavior); // @ts-ignore: Analytics.JS type should be updated with addSourceMiddleware

    wd.analytics.addSourceMiddleware(middleware);
    wd.analytics.load(writeKey, {
      integrations: integrations
    });
  }
}